module.exports = __webpack_public_path__ + "img/sceno3.1ba46deb.jpg";